import { SVG } from '../SVG'

const SecurityIcon = ({ style = {}, ...props }) => (
  <SVG
    width='50'
    height='50'
    viewBox='0 0 50 50'
    xmlns='http://www.w3.org/2000/svg'
    style={{ fill: 'var(--primary-color)', ...style }}
    {...props}
  >
    <path
      opacity='0.3'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M38.5417 16.6667C41.4182 16.6667 43.75 14.3348 43.75 11.4583C43.75 8.58185 41.4182 6.25 38.5417 6.25C35.6652 6.25 33.3333 8.58185 33.3333 11.4583C33.3333 14.3348 35.6652 16.6667 38.5417 16.6667ZM38.5417 43.75C41.4182 43.75 43.75 41.4182 43.75 38.5417C43.75 35.6652 41.4182 33.3333 38.5417 33.3333C35.6652 33.3333 33.3333 35.6652 33.3333 38.5417C33.3333 41.4182 35.6652 43.75 38.5417 43.75ZM16.6667 38.5417C16.6667 41.4182 14.3348 43.75 11.4583 43.75C8.58185 43.75 6.25 41.4182 6.25 38.5417C6.25 35.6652 8.58185 33.3333 11.4583 33.3333C14.3348 33.3333 16.6667 35.6652 16.6667 38.5417Z'
      style={{ fill: 'var(--primary-color)', ...style }}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.4583 16.6667C14.3348 16.6667 16.6667 14.3348 16.6667 11.4583C16.6667 8.58185 14.3348 6.25 11.4583 6.25C8.58185 6.25 6.25 8.58185 6.25 11.4583C6.25 14.3348 8.58185 16.6667 11.4583 16.6667ZM20.8333 9.33334C20.8333 8.78106 21.2811 8.33334 21.8333 8.33334H28.1667C28.719 8.33334 29.1667 8.78106 29.1667 9.33334V11.5C29.1667 12.0523 28.719 12.5 28.1667 12.5H21.8333C21.2811 12.5 20.8333 12.0523 20.8333 11.5V9.33334ZM21.8333 37.5C21.2811 37.5 20.8333 37.9477 20.8333 38.5V40.6667C20.8333 41.219 21.2811 41.6667 21.8333 41.6667H28.1667C28.719 41.6667 29.1667 41.219 29.1667 40.6667V38.5C29.1667 37.9477 28.719 37.5 28.1667 37.5H21.8333ZM8.33334 21.8333C8.33334 21.2811 8.78106 20.8333 9.33334 20.8333H11.5C12.0523 20.8333 12.5 21.2811 12.5 21.8333V28.1667C12.5 28.719 12.0523 29.1667 11.5 29.1667H9.33334C8.78106 29.1667 8.33334 28.719 8.33334 28.1667V21.8333ZM38.5 20.8333C37.9477 20.8333 37.5 21.2811 37.5 21.8333V28.1667C37.5 28.719 37.9477 29.1667 38.5 29.1667H40.6667C41.219 29.1667 41.6667 28.719 41.6667 28.1667V21.8333C41.6667 21.2811 41.219 20.8333 40.6667 20.8333H38.5Z'
      style={{ fill: 'var(--primary-color)', ...style }}
    />
    <path
      d='M25 27.3438C25.809 27.3438 26.4648 26.6879 26.4648 25.8789C26.4648 25.0699 25.809 24.4141 25 24.4141C24.191 24.4141 23.5352 25.0699 23.5352 25.8789C23.5352 26.6879 24.191 27.3438 25 27.3438Z'
      fill='none'
      style={{ stroke: 'var(--primary-color)', ...style }}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M25 27.3438V29.1016'
      fill='none'
      style={{ stroke: 'var(--primary-color)', ...style }}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M30.8594 22.0703H19.1406C18.817 22.0703 18.5547 22.3326 18.5547 22.6562V30.8594C18.5547 31.183 18.817 31.4453 19.1406 31.4453H30.8594C31.183 31.4453 31.4453 31.183 31.4453 30.8594V22.6562C31.4453 22.3326 31.183 22.0703 30.8594 22.0703Z'
      fill='none'
      style={{ stroke: 'var(--primary-color)', ...style }}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M22.3633 22.0703V19.4336C22.3633 18.7343 22.6411 18.0636 23.1356 17.5692C23.63 17.0747 24.3007 16.7969 25 16.7969C25.6993 16.7969 26.37 17.0747 26.8644 17.5692C27.3589 18.0636 27.6367 18.7343 27.6367 19.4336V22.0703'
      fill='none'
      style={{ stroke: 'var(--primary-color)', ...style }}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </SVG>
)

export default SecurityIcon
